const wm = {
  // ==================== LAGERVERWALTUNG ====================
  'lager.title': 'Lagerverwaltung',
  'lager.subtitle': 'Lagerbestände und Lagerbewegungen einsehen',
  'lager.tabStockOverview': 'Bestandsübersicht',
  'lager.tabGoodsReceipt': 'Wareneingang buchen',
  'lager.tabMovements': 'Bewegungen',
  'lager.searchPlaceholder': 'Material, Materialnummer oder Lagerort suchen...',
  'lager.colMaterial': 'Material',
  'lager.colMatnr': 'Materialnummer',
  'lager.colPlant': 'Werk',
  'lager.colStorageLocation': 'Lagerort',
  'lager.colQuantity': 'Menge',
  'lager.colUnit': 'Einheit',
  'lager.colStatus': 'Status',
  'lager.statusGreen': 'Ausreichend',
  'lager.statusYellow': 'Nachbestellen',
  'lager.statusRed': 'Kritisch',
  'lager.emptyStock': 'Keine Lagerbestände gefunden',
  'lager.loadingStock': 'Lagerbestände werden geladen...',
  'lager.errorStock': 'Fehler beim Laden der Lagerbestände',
  'lager.demoBadge': 'Demo',
  'lager.badgeExternal': 'Extern',
  'lager.grTitle': 'Wareneingang buchen',
  'lager.grMaterialMode': 'Materialauswahl',
  'lager.grInternalArticle': 'Interner Artikel',
  'lager.grFreeMatnr': 'Freie Materialnummer',
  'lager.grMaterial': 'Artikel',
  'lager.grMatnr': 'Materialnummer',
  'lager.grMaterialName': 'Materialbezeichnung',
  'lager.grPlant': 'Werk *',
  'lager.grStorageLocation': 'Lagerort *',
  'lager.grQuantity': 'Menge *',
  'lager.grUnit': 'Einheit',
  'lager.grReference': 'Referenz / Lieferschein',
  'lager.grSelectPlaceholder': '— Auswählen —',
  'lager.grProductIdPlaceholder': 'Artikel-ID',
  'lager.grMatnrPlaceholder': 'z.B. 100023145',
  'lager.grMaterialNamePlaceholder': 'Optionale Bezeichnung',
  'lager.grReferencePlaceholder': 'z.B. Lieferschein-Nr.',
  'lager.grSubmit': 'Wareneingang buchen',
  'lager.grSubmitting': 'Wird gebucht...',
  'lager.grSuccess': 'Wareneingang erfolgreich gebucht!',
  'lager.grErrorQtyInvalid': 'Menge muss größer als 0 sein.',
  'lager.grErrorRequired': 'Werk, Lagerort und Menge sind Pflichtfelder.',
  'lager.movementsTitle': 'Lagerbewegungen',
  'lager.emptyMovements': 'Keine Bewegungen gefunden',
  'lager.movementGoodsReceipt': 'Wareneingang',
  'lager.movementTransfer': 'Umlagerung',
  'lager.movementInventoryDiff': 'Inventurdifferenz',
  'lager.movementGoodsIssue': 'Warenausgang',
  'lager.colDate': 'Datum',
  'lager.colUser': 'Benutzer',
  'lager.colReference': 'Referenz',
  'lager.noPermission': 'Sie haben keine Berechtigung für die Lagerverwaltung.',
  'lager.detailTitle': 'Bestandsdetail',
  'lager.detailMovements': 'Bewegungshistorie',
  'lager.close': 'Schließen',
  'lager.minStock': 'Mindestbestand',
  'lager.reorderPoint': 'Meldebestand',
  'lager.filterReset': 'Filter zurücksetzen',
  'lager.filterMatnr': 'Materialnummer (exakt)',
  'lager.filterMatnrPlaceholder': 'z.B. 100023145',
  'lager.emptyMovementsFiltered': 'Keine Bewegungen für die gewählten Filter gefunden',
  'lager.loadingDetail': 'Detail wird geladen...',
  'lager.errorDetail': 'Fehler beim Laden des Bestandsdetails',

  // ==================== LAGER-MODUL Phase 1 (lm.) ====================
  'lm.title': 'Lager',
  'lm.subtitle': 'Lagermaterial suchen, Bestand einsehen und BANF erstellen',
  'lm.werkLabel': 'Werk',
  'lm.noWerk': 'Kein Werk',
  'lm.searchPlaceholder': 'Material suchen... (Nr., Name, Merkmal)',
  'lm.filterWarengruppe': 'Warengruppe',
  'lm.filterMaterialart': 'Materialart',
  'lm.filterBestand': 'Bestandsstatus',
  'lm.bestandMit': 'Mit Bestand',
  'lm.bestandOhne': 'Ohne Bestand',
  'lm.bestandAlle': 'Alle',
  'lm.resultsCount': '{count} Treffer',
  'lm.colMatnr': 'Materialnummer',
  'lm.colMaktx': 'Kurztext',
  'lm.colWarengruppe': 'Warengruppe',
  'lm.colMaterialart': 'Materialart',
  'lm.colMe': 'ME',
  'lm.colBestand': 'Frei verf. Bestand',
  'lm.colMeldebestand': 'Meldebestand',
  'lm.colPreis': 'Letzter Preis',
  'lm.colLieferant': 'Letzter Lieferant',
  'lm.colStatus': 'Status',
  'lm.iconOpenBanf': 'Offene BANF vorhanden',
  'lm.iconOpenOrder': 'Offene Bestellung vorhanden',
  'lm.iconDispo': 'Automatische Disposition aktiv',
  'lm.empty': 'Keine Materialien gefunden. Bitte passen Sie Ihre Filterkriterien an.',
  'lm.loading': 'Materialien werden geladen...',
  'lm.error': 'Fehler beim Laden der Materialien',
  'lm.perPage': 'Einträge pro Seite',
  'lm.page': 'Seite',
  'lm.filterReset': 'Filter zurücksetzen',

  // Phase 2 — Inline-Detail + Schnell-BANF
  'lm.close': 'Schließen',
  'lm.loadingDetail': 'Materialdetails werden geladen...',
  'lm.errorDetail': 'Fehler beim Laden der Materialdetails',
  'lm.detailStammdaten': 'Stammdaten',
  'lm.detailMaterialart': 'Materialart',
  'lm.detailWarengruppe': 'Warengruppe',
  'lm.detailMeins': 'Basismengeneinheit',
  'lm.detailBismt': 'Alte Materialnummer',
  'lm.detailBeskz': 'Beschaffungsart',
  'lm.detailDispo': 'Dispositionsmerkmal',
  'lm.dispoActive': 'Automatische Disposition aktiv',
  'lm.detailBestand': 'Bestandssituation',
  'lm.detailColLgort': 'Lagerort',
  'lm.detailColLgortName': 'Bezeichnung',
  'lm.detailColFrei': 'Frei verfügbar',
  'lm.detailColQp': 'Qualitätsprüfung',
  'lm.detailColGesperrt': 'Gesperrt',
  'lm.detailGesamt': 'GESAMT',
  'lm.detailStockOwn': 'Eigener Bestand',
  'lm.detailStockVendorConsignment': 'Konsignation (Lieferant)',
  'lm.detailStockAtVendor': 'Bestand beim Lieferanten',
  'lm.detailColLieferant': 'Lieferant',
  'lm.detailVerfuegbarGesamt': 'Verfügbar gesamt (Eigen + Konsignation)',
  'lm.colDavonKonsi': 'davon Konsi.',
  'lm.colBeimLieferant': 'beim Lieferant',
  'lm.filterBestandsqualitaet': 'Bestandsqualität',
  'lm.filterKonsignation': 'Nur mit Konsignation',
  'lm.filterSonderbestand': 'Sonderbestandsart',
  'lm.stockTypeOwn': 'Eigenbestand',
  'lm.stockTypeKonsi': 'Konsignation',
  'lm.stockTypeAtVendor': 'Beim Lieferanten',
  'lm.filterLieferant': 'Lieferant',
  'lm.filterEinkaeufergruppe': 'Einkäufergruppe',
  'lm.filterSperrbestand': 'Sperrbestand',
  'lm.filterQmbestand': 'QM-Bestand',
  'lm.detailMeldebestand': 'Meldebestand',
  'lm.detailSicherheitsbestand': 'Sicherheitsbestand',
  'lm.schnellBanf': 'Schnell-BANF',
  'lm.banfMenge': 'Menge',
  'lm.banfLieferdatum': 'Wunsch-Lieferdatum',
  'lm.banfLieferant': 'Wunschlieferant',
  'lm.banfOhneLieferant': 'Ohne Lieferant (Einkauf entscheidet)',
  'lm.banfGeschaetzterPreis': 'Geschätzter Preis',
  'lm.banfInBanf': 'In BANF übernehmen',
  'lm.banfZurDetailBanf': 'Zur Detail-BANF',
  'lm.banfAuftragErstellen': 'Auftrag erstellen',
  'lm.auftragComingSoon': 'Auftragserstellung folgt (PM/Instandhaltung).',
  'lm.banfAdded': 'Artikel wurde in den Warenkorb übernommen',
  'lm.banfMengeRequired': 'Bitte eine Menge > 0 eingeben',
  'lm.banfLieferdatumRequired': 'Bitte ein Lieferdatum wählen',
  'lm.detailLetzterPreis': 'Letzter Preis',
  'lm.detailLetzterLieferant': 'Letzter Lieferant',

  // Phase 3a — Lieferanten-Block
  'lm.suppliersTitle': 'Lieferanten & Konditionen',
  'lm.suppliersLoading': 'Lieferanten werden geladen...',
  'lm.suppliersEmpty': 'Keine Lieferanteninfosätze vorhanden.',
  'lm.suppliersError': 'Fehler beim Laden der Lieferanten',
  'lm.suppliersColSupplier': 'Lieferant',
  'lm.suppliersColNetpr': 'Nettopreis',
  'lm.suppliersColPeinh': 'PE',
  'lm.suppliersColCurrency': 'Währung',
  'lm.suppliersColDelivery': 'Lieferzeit',
  'lm.suppliersColContract': 'Vertrag',
  'lm.suppliersColValidTo': 'Gültig bis',
  'lm.suppliersCheapest': 'Günstigster Lieferant',
  'lm.suppliersPerUnit': 'pro Stk.',
  'lm.suppliersDeliveryDays': '{days} Tage',
  'lm.suppliersNoContract': '—',

  // Phase 3a — Bestellhistorie-Block
  'lm.purchaseHistoryTitle': 'Letzte Bestellungen',
  'lm.purchaseHistoryLoading': 'Bestellhistorie wird geladen...',
  'lm.purchaseHistoryEmpty': 'Keine Bestellhistorie vorhanden.',
  'lm.purchaseHistoryError': 'Fehler beim Laden der Bestellhistorie',
  'lm.purchaseHistoryColEbeln': 'Bestell-Nr.',
  'lm.purchaseHistoryColSupplier': 'Lieferant',
  'lm.purchaseHistoryColMenge': 'Menge',
  'lm.purchaseHistoryColNetpr': 'Nettopreis',
  'lm.purchaseHistoryColDate': 'Bestelldatum',

  // Phase 3a — Klassifizierungs-Block
  'lm.classificationTitle': 'Klassifizierungsmerkmale',
  'lm.classificationLoading': 'Merkmale werden geladen...',
  'lm.classificationEmpty': 'Keine Klassifizierungsmerkmale vorhanden.',
  'lm.classificationError': 'Fehler beim Laden der Merkmale',

  // Phase 3a — Schnell-BANF Lieferantenauswahl
  'lm.banfSupplierSelect': 'Wunschlieferant aus Infosatz',
  'lm.banfSupplierDelivery': 'Lieferzeit {days} Tage',

  // Phase 3b — Erweiterte Filter
  'lm.moreFilters': 'Mehr Filter',
  'lm.lessFilters': 'Weniger Filter',
  'lm.advancedFiltersTitle': 'Erweiterte Filter',
  'lm.filterLagerort': 'Lagerort',
  'lm.filterBeschaffungsart': 'Beschaffungsart',
  'lm.filterDispomerkmal': 'Dispositionsmerkmal',
  'lm.filterBestandVon': 'Bestand von',
  'lm.filterBestandBis': 'Bestand bis',
  'lm.filterOffeneBanf': 'Offene BANF',
  'lm.filterOffeneBestellung': 'Offene Bestellung',
  'lm.filterMit': 'Mit',
  'lm.filterOhne': 'Ohne',
  'lm.filterAlle': 'Alle',
  'lm.beschaffungsartF': 'Fremdbeschaffung',
  'lm.beschaffungsartE': 'Eigenfertigung',
  'lm.beschaffungsartX': 'Beide',
  'lm.handlungsbedarf': 'Handlungsbedarf',
  'lm.handlungsbedarfHint': 'Bestand unter Meldebestand, keine offene BANF/Bestellung — rein informativ',
  'lm.advancedFilterReset': 'Alle Filter zurücksetzen',

  // Phase 3b — Gespeicherte Filter
  'lm.savedFiltersTitle': 'Gespeicherte Filter',
  'lm.saveCurrent': 'Aktuelle Filter speichern',
  'lm.saveModalTitle': 'Filter speichern',
  'lm.saveModalName': 'Filtername',
  'lm.saveModalNamePlaceholder': 'z. B. Mein Hauptlager-Filter',
  'lm.save': 'Speichern',
  'lm.cancel': 'Abbrechen',
  'lm.deleteConfirm': 'Filter wirklich löschen?',
  'lm.emptySaved': 'Keine gespeicherten Filter vorhanden.',
  'lm.savedFilterApplied': 'Filter wurde angewendet',
  'lm.savedFilterSaved': 'Filter gespeichert',
  'lm.savedFilterDeleted': 'Filter gelöscht',
  'lm.savedFilterSaveError': 'Filter konnte nicht gespeichert werden',
  'lm.savedFilterDeleteError': 'Filter konnte nicht gelöscht werden',
  'lm.savedFilterNameRequired': 'Bitte einen Namen eingeben',

  // Phase 3c — Klassifizierungs-Merkmals-Filter
  'lm.merkmaleTitle': 'Klassifizierungsmerkmale',
  'lm.merkmaleSelectWg': 'Bitte eine Warengruppe wählen, um Merkmale zu filtern',
  'lm.merkmaleLoading': 'Merkmale werden geladen...',
  'lm.merkmaleError': 'Fehler beim Laden der Merkmale',
  'lm.merkmaleEmpty': 'Keine Klassifizierungsmerkmale für die gewählten Warengruppen vorhanden.',
  'lm.merkmaleVon': 'von',
  'lm.merkmaleBis': 'bis',
  'lm.merkmaleLoadError': 'Fehler beim Laden der Klassifizierungsoptionen',

  // Phase 4 — Dashboard
  'lm.dashTitle': 'Lager-Dashboard',
  'lm.dashMonitoring': 'Monitoring',
  'lm.dashBack': 'Zurück zur Übersicht',
  'lm.dashLoading': 'Dashboard wird geladen...',
  'lm.dashError': 'Fehler beim Laden des Dashboards',
  'lm.dashEmpty': 'Keine Dashboard-Daten verfügbar',
  'lm.dashMock': 'Demo',
  'lm.dashBestandswert': 'Gesamtbestandswert',
  'lm.dashKritisch': 'Kritische Bestände',
  'lm.dashOffeneBanf': 'Offene BANFen',
  'lm.dashUmschlag': 'Lagerumschlag',
  'lm.dashUmschlagUnit': 'x / Jahr',
  'lm.dashVerlauf': 'Bestandsverlauf (12 Monate)',
  'lm.mockBadge': 'Mock-Daten',
  'lm.dashDurchlaufzeiten': 'Durchlaufzeiten nach Warengruppe',
  'lm.dashDurchlaufDays': 'Tage',
  'lm.dashTopMaterial': 'Top 5 Materialien nach Wert',
  'lm.dashColMatnr': 'Materialnr.',
  'lm.dashColMaktx': 'Kurztext',
  'lm.dashColBestand': 'Bestand',
  'lm.dashColWert': 'Wert (EUR)',
  'lm.dashAktivitaeten': 'Letzte Lageraktivitäten',
  'lm.dashActWareneingang': 'Wareneingang',
  'lm.dashActAuslagerung': 'Auslagerung',
  'lm.dashActUmlagerung': 'Umlagerung',
  'lm.dashActMaterial': 'Material',
  'lm.dashActMenge': 'Menge',
  'lm.dashActDatum': 'Datum',
  'lm.dashActBenutzer': 'Benutzer',
  'lm.dashKritischUnit': 'Materialien',
  'lm.dashOffeneBanfUnit': 'Anforderungen',

  // Lager-Shell / Sidebar / Drill-down (Phase Dashboard-v2)
  'lm.navDashboard': 'Dashboard',
  'lm.navLagerbestand': 'Lagerbestand',
  'lm.navBanfStatus': 'BANF-Status',
  'lm.navDurchlaufzeiten': 'Durchlaufzeiten',
  'lm.navBerichte': 'Berichte',
  // Durchlaufzeiten-Sektion
  'lm.dlzTitle': 'Durchlaufzeiten – geplante Lieferzeiten',
  'lm.dlzSubtitle': 'Geplante Lieferzeiten (Infosatz) je Warengruppe & Lieferant · Zielzeit {target} Tage',
  'lm.dlzEmpty': 'Keine Lieferzeit-Daten (Infosätze) vorhanden.',
  'lm.dlzNoWerk': 'Bitte zuerst ein Werk wählen (z. B. im Dashboard oder Lagerbestand).',
  'lm.dlzDays': 'Tage',
  'lm.dlzOk': 'Planmäßig',
  'lm.dlzWatch': 'Grenzwertig',
  'lm.dlzRisk': 'Zu lang',
  'lm.dlzKpiAvg': 'Ø geplante Lieferzeit',
  'lm.dlzTargetSub': 'Ziel {target} Tage',
  'lm.dlzKpiFastest': 'Schnellste Warengruppe',
  'lm.dlzKpiSlowest': 'Langsamste Warengruppe',
  'lm.dlzKpiRisk': 'Risiko-Warengruppen',
  'lm.dlzKpiRiskSub': '> Ziel {target} Tage',
  'lm.dlzKpiAvgInfo': 'Material-gewichteter Durchschnitt der geplanten Lieferzeiten (Infosatz APLFZ) über alle Warengruppen des Werks.',
  'lm.dlzKpiFastestInfo': 'Warengruppe mit dem niedrigsten Durchschnitt der geplanten Lieferzeiten.',
  'lm.dlzKpiSlowestInfo': 'Warengruppe mit dem höchsten Durchschnitt der geplanten Lieferzeiten.',
  'lm.dlzKpiRiskInfo': 'Anzahl Warengruppen, deren Ø mehr als 20% über der Zielzeit ({target} T) liegt.',
  'lm.dlzKpiSingleSource': 'Single-Source-Risiko',
  'lm.dlzKpiSingleSourceSub': 'von {total} Materialien',
  'lm.dlzKpiSingleSourceInfo': 'Materialien mit nur EINEM Infosatz-Lieferant — Versorgungsrisiko, keine Ausweichquelle.',
  'lm.dlzKpiSavings': 'Einsparpotenzial',
  'lm.dlzKpiSavingsSub': '{count} Mat. mit Alternativen',
  'lm.dlzKpiSavingsInfo': 'Median der Preis-Spanne (teuerster vs. günstigster Lieferant je Material). Median = robust gegen Ausreißer.',
  'lm.dlzKpiSpread': 'Lead-time-Streuung',
  'lm.dlzKpiSpreadSub': 'langsamste − schnellste WG',
  'lm.dlzKpiSpreadInfo': 'Differenz langsamste − schnellste Warengruppe (Ø geplante Lieferzeit). Je Balken: Min–Max-Spanne.',
  'lm.dlzByWg': 'Lieferzeit je Warengruppe',
  'lm.dlzColZiel': 'Ziel',
  'lm.dlzLegende': 'Ampel: grün ≤ Ziel · gelb bis +20% · rot darüber. Gestrichelt = Zielzeit.',
  'lm.dlzSupplierTitle': 'Lieferanten-Vergleich',
  'lm.dlzColLieferant': 'Lieferant',
  'lm.dlzColMaterialien': 'Materialien',
  'lm.dlzColWg': 'Warengruppen',
  'lm.dlzColLieferzeit': 'Ø Lieferzeit',
  'lm.dlzColStatus': 'Status',
  'lm.dlzSapHint': 'IST-Durchlaufzeiten, Liefertreue (OTD), Compliance und Trend folgen mit der SAP-Wareneingangs-Historie (EKBE). Aktuell: geplante Lieferzeiten aus den Infosätzen.',
  // Berichte-Sektion
  'lm.berichteTitle': 'Berichte',
  'lm.berichteSubtitle': 'Kennzahlen & Export-Berichte',
  'lm.repKpiBanfMonat': 'BANFs diesen Monat',
  'lm.repKpiBanfMonatSub': 'neu erstellt',
  'lm.repKpiWertJahr': 'Bestellwert (Jahr)',
  'lm.repKpiWertJahrSub': 'Summe BANFs',
  'lm.repKpiOffen': 'Offene BANFs',
  'lm.repKpiOffenSub': 'Genehmigung ausstehend',
  'lm.repHubTitle': 'Export-Berichte (.xlsx)',
  'lm.repBestand': 'Bestandsliste',
  'lm.repBestandDesc': 'Alle Materialien mit Bestand',
  'lm.repHandlung': 'Handlungsbedarf',
  'lm.repHandlungDesc': 'Unter Meldebestand, ohne offene BANF/Bestellung',
  'lm.repKritisch': 'Kritische Bestände',
  'lm.repKritischDesc': 'Unter Sicherheitsbestand / kritisch',
  'lm.repKonsi': 'Sonderbestände',
  'lm.repKonsiDesc': 'Konsignation + Beistellung — mit Art, SOBKZ & Lieferant',
  'lm.repAlle': 'Kompletter Bestand',
  'lm.repAlleDesc': 'Alle Materialien des Werks',
  'lm.repBanf': 'BANF-Liste',
  'lm.repBanfDesc': 'Bestellanforderungen dieses Jahr',
  'lm.repDownload': 'Excel herunterladen',
  'lm.repError': 'Export fehlgeschlagen',
  'lm.repEmpty': '0 Treffer in diesem Werk — nichts zu exportieren.',
  'lm.repHubHint': 'Berichte nutzen die aktuelle Lager-Filter-/Export-Logik; je Werk gescoped.',
  // BANF-Status-Sektion
  'lm.banfTitle': 'Offene Bestellanforderungen',
  'lm.banfSubtitle': '{count} BANFen',
  'lm.banfKpiPending': 'Genehmigung ausstehend',
  'lm.banfKpiPendingUnit': 'offen',
  'lm.banfKpiApproved': 'Genehmigt',
  'lm.banfKpiApprovedUnit': 'freigegeben',
  'lm.banfKpiRisiko': 'Mit Lieferrisiko',
  'lm.banfKpiRisikoUnit': 'Bedarf nah / überfällig',
  'lm.banfKpiWert': 'Gesamtwert',
  'lm.banfKpiWertUnit': 'alle BANFen',
  'lm.banfFilterAlle': 'Alle Status',
  'lm.banfFilterPending': 'Offen',
  'lm.banfFilterApproved': 'Genehmigt',
  'lm.banfFilterRejected': 'Abgelehnt',
  'lm.banfSearch': 'BANF-Nr., Kurztext oder Material suchen…',
  'lm.banfAllWerke': 'Alle Werke',
  'lm.banfFilterWerk': 'Werk',
  'lm.banfAllWg': 'Alle Warengruppen',
  'lm.banfAllAnf': 'Alle Anforderer',
  'lm.banfRiskOnly': 'Nur mit Lieferrisiko',
  'lm.banfSort': 'Sortieren',
  'lm.banfSortBedarf': 'Bedarfstermin',
  'lm.banfSortDatum': 'Anforderungsdatum',
  'lm.banfSortWert': 'Wert',
  'lm.banfBedarf': 'Bedarfstermin',
  'lm.banfBedarfVon': 'Bedarf ab',
  'lm.banfBedarfBis': 'Bedarf bis',
  'lm.banfRiskBadge': 'Lieferrisiko',
  'lm.banfErstelltAm': 'Erstellt',
  'lm.banfEmpty': 'Keine Bestellanforderungen gefunden.',
  'lm.banfStepErstellt': 'Erstellt',
  'lm.banfStepGenehmigt': 'Genehmigt',
  'lm.banfStepBestellt': 'Bestellt',
  'lm.banfStepGeliefert': 'Geliefert',
  'lm.banfDetailAnforderer': 'Anforderer',
  'lm.banfDetailKostenstelle': 'Kostenstelle (Anforderer)',
  'lm.banfDetailPos': 'Pos',
  'lm.banfDetailMenge': 'Menge',
  'lm.banfDetailWerk': 'Werk / Lagerort',
  'lm.banfDetailKontierung': 'Kontierung',
  'lm.banfDetailWunschlief': 'Wunschlieferant',
  'lm.banfFilterStatus': 'Status',
  'lm.banfFilterWg': 'Warengruppe',
  'lm.banfFilterAnforderer': 'Anforderer',
  'lm.banfFilterKostenstelle': 'Kostenstelle',
  'lm.banfFilterAuftrag': 'Auftrag',
  'lm.banfFilterSachkonto': 'Sachkonto',
  'lm.rememberFilter': 'Filter merken',
  'lm.rememberFilterHint': 'Aktuellen Filter merken und beim nächsten Login automatisch anwenden',
  'lm.banfSortKostenstelle': 'Kostenstelle',
  'lm.banfSortAuftrag': 'Auftrag',
  'lm.banfKontierung': 'Kontierung',
  'lm.banfKontKostenstelle': 'Kostenstelle',
  'lm.banfKontSachkonto': 'Sachkonto',
  'lm.banfKontAuftrag': 'Auftrag',
  'lm.banfKontPsp': 'PSP-Element',
  'lm.banfReset': 'Zurücksetzen',
  'lm.banfResetAll': 'Alle Filter zurücksetzen',
  'lm.banfSearchOpt': 'Suchen…',
  'lm.dashSoon': 'Demnächst verfügbar',
  'lm.kritischChip': 'Kritischer Bestand',
  'lm.backToHome': 'Zur Startseite',
  'lm.drilldownClickable': 'Klicken für Details',

  // ATP / Verfuegbarkeit (Phase 4c)
  'lm.atpTitle': 'ATP / Verfügbarkeit (MD04)',
  'lm.atpLoading': 'Verfügbarkeit wird geladen...',
  'lm.atpError': 'Fehler beim Laden der Verfügbarkeit',
  'lm.atpEmpty': 'Keine Dispositionsdaten vorhanden',
  'lm.atpBestand': 'Bestand',
  'lm.atpZugaenge': 'Erwartete Zugänge',
  'lm.atpAbgaenge': 'Geplante Abgänge',
  'lm.atpVerfuegbarNetto': 'Verfügbar (Netto)',
  'lm.atpExpand': 'Details einblenden',
  'lm.atpCollapse': 'Details ausblenden',
  'lm.atpZugaengeTitle': 'Zugänge',
  'lm.atpAbgaengeTitle': 'Abgänge',
  'lm.atpElementTyp': 'Elementtyp',
  'lm.atpBeleg': 'Beleg',
  'lm.atpMenge': 'Menge',
  'lm.atpTermin': 'Termin',
  'lm.atpZugaengeEmpty': 'Keine Zugänge geplant',
  'lm.atpAbgaengeEmpty': 'Keine Abgänge geplant',

  // Export-Buttons (Dashboard-v2 Runde D)
  'lm.exportXlsx': 'Excel exportieren',
  'lm.exportDetailXlsx': 'Detail als Excel',
  'lm.exportLoading': 'Export läuft...',
  'lm.exportError': 'Export fehlgeschlagen',
};

export default wm;
